import { render, staticRenderFns } from "./WhoopsView.vue?vue&type=template&id=6cd668c8&scoped=true&"
import script from "./WhoopsView.vue?vue&type=script&lang=ts&"
export * from "./WhoopsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd668c8",
  null
  
)

export default component.exports